import React, { createContext, useContext, useState, useMemo } from "react";
import { translations } from "@/i18n";

const LangContext = createContext({ lang: "es", setLang: () => {}, t: translations.es });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("es");
  const value = useMemo(() => ({ lang, setLang, t: translations[lang] }), [lang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
